import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth } from '@angular/fire/auth';
import { ExcelImportService } from '../services/excel-import.service';

@Component({
  selector: 'app-excel-uploader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './excel-uploader.component.html',
  styleUrls: ['./excel-uploader.component.css']
})
export class ExcelUploaderComponent implements OnChanges {
  @Input() selectedPeriod: string = '';
  @Input() isImporting: boolean = false;
  @Input() importProgress: number = 0;
  @Output() fileSelected = new EventEmitter<File>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  
  isUploading = false;
  uploadMessage = '';
  progress = 0;

  private auth = inject(Auth);
  constructor(private excelService: ExcelImportService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedPeriod']) {
      this.resetStatus();
    }
  }

  onInputClick() {
    this.resetStatus();
    if (this.fileInput?.nativeElement) this.fileInput.nativeElement.value = '';
  }

  onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.fileSelected.emit(target.files[0]);
      target.value = '';
    }
  }

  private resetStatus() {
    this.uploadMessage = '';
    this.progress = 0;
    this.isUploading = false;
  }

}